import type { CreditCardStatus } from '@chargify/custom-ui-components';
import { PaymentProfileStatus } from '../../models';

export const PAYMENT_PROFILE_STATUS: Record<
  PaymentProfileStatus,
  CreditCardStatus
> = {
  active: 'active',
  expired: 'error',
  unavailable: 'unavailable',
  normal: null,
};
